//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { auth, version, sync } from '@/api/setting';
export default {
  data: function data() {
    return {
      baseUrl: 'https://doc.tuoluojiang.com/auth',
      iframeUrl: '',
      authCode: '',
      authTime: '',
      status: 1,
      dayNum: 0,
      copyright: '',
      isTemplate: false,
      copyrightText: '',
      payType: '',
      isShow: false,
      // 验证码模态框是否出现
      active: 0,
      timer: null,
      version: '',
      label: '',
      productType: ''
    };
  },
  created: function created() {
    this.getVersion();
    this.getAuth();
  },
  mounted: function mounted() {},
  methods: {
    getVersion: function getVersion() {
      var _this = this;
      version().then(function (res) {
        _this.version = res.data.version;
        _this.label = res.data.label;
      });
    },
    //   获取商业授权信息
    getAuth: function getAuth() {
      var _this2 = this;
      auth().then(function (res) {
        var data = res.data || {};
        _this2.authCode = data.authCode || '';
        _this2.authTime = data.day || '';
        _this2.status = data.status === undefined ? -1 : data.status;
        _this2.dayNum = data.day || 0;
        _this2.copyright = data.copyright;
      });
    },
    // 申请商业授权
    payment: function payment(product) {
      this.productType = product;
      var host = location.host;
      var uniqued = JSON.parse(localStorage.getItem('enterprise')).uniqued;
      var name = JSON.parse(localStorage.getItem('enterprise')).enterprise_name;
      var hostData = host.split('.');
      if (hostData[0] === 'test' && hostData.length === 4) {
        host = host.replace('test.', '');
      } else if (hostData[0] === 'www' && hostData.length === 3) {
        host = host.replace('www.', '');
      }
      this.iframeUrl = this.baseUrl + '?host=' + host + '&uniqued=' + uniqued + '&name=' + name;
      this.isTemplate = true;
    },
    cancel: function cancel() {
      this.iframeUrl = '';
      this.isTemplate = false;
    },
    // 进入官网
    toCrmeb: function toCrmeb() {
      window.open('https://doc.tuoluojiang.com');
    }
  }
};